export default function setStaticNav(staticHeader: HTMLDivElement | null) {
  const root = document.getElementById('gn-root') as HTMLDivElement;
  if (root && staticHeader) {
    root.appendChild(staticHeader);
  }
}
